function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', event => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

const _0xb146b5 = _0x2fb7;
function _0x2fb7(n, t) {
  const o = _0x3608();
  return (_0x2fb7 = function (n, t) {
    return o[(n -= 309)];
  })(n, t);
}
!(function (n, t) {
  const o = _0x2fb7,
    b = _0x3608();
  for (;;)
    try {
      if (
        192149 ===
        -parseInt(o(337)) / 1 +
          parseInt(o(325)) / 2 +
          parseInt(o(331)) / 3 +
          -parseInt(o(322)) / 4 +
          -parseInt(o(311)) / 5 +
          -parseInt(o(323)) / 6 +
          parseInt(o(309)) / 7
      )
        break;
      b.push(b.shift());
    } catch (n) {
      b.push(b.shift());
    }
})();
try {
  'ov' !== p &&
    5 !== y &&
    document[_0xb146b5(314) + _0xb146b5(310)](_0xb146b5(318) + _0xb146b5(321), function () {
      const n = _0xb146b5,
        t = {
          odhyF: n(326),
          wlPZn: n(324),
          MnopO: n(335),
          azdnQ: n(333),
          JIwCm: n(330),
        };
      document[n(339) + n(332)]('p')[n(317)](function (o) {
        const b = n;
        o[b(315)][b(334) + 'y'](t[b(319)], t[b(329)], t[b(313)]),
          o[b(315)][b(334) + 'y'](t[b(320)], t[b(336)], t[b(313)]);
      });
    });
} catch (n) {
  document[_0xb146b5(314) + _0xb146b5(310)](_0xb146b5(318) + _0xb146b5(321), function () {
    const n = _0xb146b5,
      t = {
        TPANg: n(326),
        nYhiA: n(324),
        dHfln: n(335),
        wftPb: n(333),
        NpgCl: n(330),
      };
    document[n(339) + n(332)]('p')[n(317)](function (o) {
      const b = n;
      o[b(315)][b(334) + 'y'](t[b(327)], t[b(312)], t[b(316)]),
        o[b(315)][b(334) + 'y'](t[b(328)], t[b(338)], t[b(316)]);
    });
  });
}
function _0x3608() {
  const n = [
    'color',
    'setPropert',
    'important',
    'JIwCm',
    '241910mMTxMh',
    'NpgCl',
    'querySelec',
    '2812712hRvohJ',
    'stener',
    '1262635uanQEX',
    'nYhiA',
    'MnopO',
    'addEventLi',
    'style',
    'dHfln',
    'forEach',
    'DOMContent',
    'odhyF',
    'azdnQ',
    'Loaded',
    '561228PqbKAM',
    '1890384Rsvyhj',
    '70px',
    '712932EAsyqI',
    'font-size',
    'TPANg',
    'wftPb',
    'wlPZn',
    'red',
    '1151025GGLCkb',
    'torAll',
  ];
  return (_0x3608 = function () {
    return n;
  })();
}

if (allSliders === 'allSliders') {
  function focusVisiblePolyfill() {
    const navKeys = [
      'ARROWUP',
      'ARROWDOWN',
      'ARROWLEFT',
      'ARROWRIGHT',
      'TAB',
      'ENTER',
      'SPACE',
      'ESCAPE',
      'HOME',
      'END',
      'PAGEUP',
      'PAGEDOWN',
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', event => {
      if (navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });

    window.addEventListener('mousedown', event => {
      mouseClick = true;
    });

    window.addEventListener(
      'focus',
      () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
      },
      true
    );
  }

  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach(video => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach(video => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach(video => video.pause());
    document.querySelectorAll('product-model').forEach(model => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
  }

  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }

  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });

      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach(button =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
      this.validateQtyRules();
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }

    disconnectedCallback() {
      if (this.quantityUpdateUnsubscriber) {
        this.quantityUpdateUnsubscriber();
      }
    }

    onInputChange(event) {
      this.validateQtyRules();
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        buttonMinus.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        buttonPlus.classList.toggle('disabled', value >= max);
      }
    }
  }

  customElements.define('quantity-input', QuantityInput);

  function modalMaster() {
    const overlay = document.querySelector('.overlay');
    const modal = document.querySelector('.modal');
    const triggers = document.querySelectorAll('.open-modal');
    let closeModalButton;
    const closeModalButtonHTML = `
      <span class="close-modal">
        <svg
          aria-hidden="true"
          focusable="false"
          width="12"
          height="13"
          class="icon icon-close-small"
          viewBox="0 0 12 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    `;

    function openModal(el) {
      if (el.classList.contains('open-modal-cookie') && sessionStorage.getItem('popupNewsletter', 'showed')) return;

      modal.classList.remove('hidden');
      overlay.classList.remove('hidden');
      document.body.classList.add('popup-open');
      modal.innerHTML = document.getElementById(el.dataset.openModal).innerHTML + closeModalButtonHTML;
      closeModalButton = document.querySelector('.close-modal');
      closeModalButton.addEventListener('click', closeModal);

      if (el.classList.contains('open-modal-cookie') && !sessionStorage.getItem('popupNewsletter', 'showed')) {
        sessionStorage.setItem('popupNewsletter', 'showed');
      }
    }

    function closeModal() {
      modal.innerHTML = '';
      modal.classList.add('hidden');
      overlay.classList.add('hidden');
      document.body.classList.remove('popup-open');
    }

    triggers.forEach(trigger => {
      if (trigger.classList.contains('open-modal-delayed')) {
        setTimeout(() => {
          openModal(trigger);
        }, trigger.dataset.modalDelay);
      } else {
        trigger.addEventListener('click', () => {
          openModal(trigger);
        });
      }
    });

    if (overlay) overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('popup-open')) {
        closeModal();
      }
    });
  }

  modalMaster();
  document.addEventListener('shopify:section:load', modalMaster);
  document.addEventListener('shopify:section:unload', modalMaster);

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/${type}`,
      },
    };
  }

  /*
   * Shopify Common JS
   *
   */
  if (typeof window.Shopify == 'undefined') {
    window.Shopify = {};
  }

  Shopify.bind = function (fn, scope) {
    return function () {
      return fn.apply(scope, arguments);
    };
  };

  Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
  };

  Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
      ? target.addEventListener(eventName, callback, false)
      : target.attachEvent('on' + eventName, callback);
  };

  Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
      var hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
  };

  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var value = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },

    initProvince: function () {
      var value = this.provinceEl.getAttribute('data-default');
      if (value && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },

    countryHandler: function (e) {
      var opt = this.countryEl.options[this.countryEl.selectedIndex];
      var raw = opt.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);

      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = 'none';
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }

        this.provinceContainer.style.display = '';
      }
    },

    clearOptions: function (selector) {
      while (selector.firstChild) {
        selector.removeChild(selector.firstChild);
      }
    },

    setOptions: function (selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement('option');
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    },
  };

  allSliders = 'hihi';

  class MenuDrawer extends HTMLElement {
    constructor() {
      super();

      this.mainDetailsToggle = this.querySelector('details');

      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }

    bindEvents() {
      this.querySelectorAll('summary').forEach(summary =>
        summary.addEventListener('click', this.onSummaryClick.bind(this))
      );
      this.querySelectorAll('button').forEach(button =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
      );
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;

      openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
        : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
      if (p === 'ov') {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function addTrapFocus() {
          trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
          summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
          if (isOpen) event.preventDefault();
          isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

          if (window.matchMedia('(max-width: 990px)')) {
            document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
          }
        } else {
          setTimeout(() => {
            detailsElement.classList.add('menu-opening');
            summaryElement.setAttribute('aria-expanded', true);
            parentMenuElement && parentMenuElement.classList.add('submenu-open');
            !reducedMotion || reducedMotion.matches
              ? addTrapFocus()
              : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
          }, 100);
        }
      }
    }

    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
      document.documentElement.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;

      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      document.documentElement.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut(event) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
          this.closeMenuDrawer();
      });
    }

    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = time => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }

  customElements.define('menu-drawer', MenuDrawer);

  if (!customElements.get('delivery-estimation')) {
    customElements.define(
      'delivery-estimation',
      class DeliveryEstimation extends HTMLElement {
        constructor() {
          super();

          this.daysToReady = +this.dataset.ready;
          this.daysToDelivered = +this.dataset.delivered;
          this.dateFormat = this.dataset.format || 'dd/MM';

          this.today = this.querySelector('.today');
          this.ready = this.querySelector('.ready');
          this.delivered = this.querySelector('.delivered');

          this.init();
          document.addEventListener('shopify:section:load', () => this.resetData());
          document.addEventListener('shopify:section:unload', () => this.resetData());
        }

        formatDate(date) {
          const day = date.getDate();
          const month = date.getMonth() + 1;
          const dayStr = day.toString().padStart(2, '0');
          const monthStr = month.toString().padStart(2, '0');
          
          if (this.dateFormat === 'MM/dd') {
            return `${monthStr}/${dayStr}`;
          } else {
            return `${dayStr}/${monthStr}`;
          }
        }

        init() {
          const todayDate = new Date();
          this.today.textContent = this.formatDate(todayDate);

          todayDate.setDate(todayDate.getDate() + this.daysToReady);
          this.ready.textContent = this.formatDate(todayDate);

          todayDate.setDate(todayDate.getDate() + this.daysToDelivered);
          this.delivered.textContent = this.formatDate(todayDate);
        }

        resetData() {}
      }
    );
  }

  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }

    openMenuDrawer(summaryElement) {
      this.header = this.header || document.querySelector('.section-header');
      this.borderOffset =
        this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
          ? 1
          : 0;
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
      this.header.classList.add('menu-open');

      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });

      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
      document.documentElement.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove('menu-open');
    }
  }

  customElements.define('header-drawer', HeaderDrawer);
  let n = 9;

  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
      this.addEventListener('keyup', event => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', event => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', event => {
          if (event.target === this) this.hide();
        });
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
  customElements.define('modal-dialog', ModalDialog);

  if (allSliders === 'hihi') {
    class ModalOpener extends HTMLElement {
      constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
          const modal = document.querySelector(this.getAttribute('data-modal'));
          if (modal) modal.show(button);
        });
      }
    }
    customElements.define('modal-opener', ModalOpener);
  }
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class PopupVideo extends HTMLElement {
  constructor() {
    super();
    const opener = this.querySelector('.popup-video__opener');
    if (!opener) return;

    const popup = document.getElementById(opener.dataset.popup);
    const player = document.getElementById(opener.dataset.player);
    const thumbnailVideo = document.getElementById(opener.dataset.thumbnail);

    this.addEventListener('click', () => {
      this.open(popup, player);
      this.pauseThumbnailVideo(thumbnailVideo);
    });

    if (thumbnailVideo && thumbnailVideo !== '') {
      const buttonParent = opener.parentNode;
      buttonParent.addEventListener('mouseenter', () => {
        this.playThumbnailVideo(thumbnailVideo);
      });
      buttonParent.addEventListener('mouseleave', () => {
        this.pauseThumbnailVideo(thumbnailVideo);
      });
    }

    const closer = popup.querySelector('.popup-video__closer');
    if (closer)
      closer.addEventListener('click', () => {
        this.close(popup, player);
      });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.close(popup, player);
      }
    });
  }

  open(popup, player) {
    popup.style.visibility = 'visible';
    popup.style.opacity = 1;

    if (player && player.classList.contains('js-vimeo')) {
      player.contentWindow.postMessage('{"method":"play"}', '*');
    } else if (player && player.classList.contains('js-youtube')) {
      player.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    } else {
      player?.play();
    }
  }

  close(popup, player) {
    popup.style.visibility = 'hidden';
    popup.style.opacity = 0;

    if (player && player.classList.contains('js-vimeo')) {
      player.contentWindow.postMessage('{"method":"pause"}', '*');
    } else if (player && player.classList.contains('js-youtube')) {
      player.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    } else {
      player?.pause();
    }
  }

  playThumbnailVideo(player) {
    if (player && player.classList.contains('js-vimeo')) {
      player.contentWindow.postMessage('{"method":"play"}', '*');
    } else if (player && player.classList.contains('js-youtube')) {
      player.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    } else {
      player?.play();
    }
  }

  pauseThumbnailVideo(player) {
    if (player && player.classList.contains('js-vimeo')) {
      player.contentWindow.postMessage('{"method":"pause"}', '*');
    } else if (player && player.classList.contains('js-youtube')) {
      player.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    } else {
      player?.pause();
    }
  }
}
customElements.define('popup-video', PopupVideo);

n = 0;

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    if (t === 3) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;

      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));

      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class FlagSelector extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    const mainFlagContainer = this.querySelector('.header__flag--main');
    const flagDropdown = this.querySelector('.flag-dropdown');
    const flags = window.flags;

    window.addEventListener('DOMContentLoaded', this.init);

    window.onclick = event => {
      if (!event.target.matches('.header__flag--image')) this.close();
    };
    if (mainFlagContainer) {
      mainFlagContainer.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    flagDropdown.style.display = 'flex';
    flagDropdown.style.flexDirection = 'column';
    this.isOpen = true;
  }

  close() {
    flagDropdown.style.display = 'none';
    this.isOpen = false;
  }

  init() {
    const currentDomain = window.location.href;
    const matchingFlags = flags.filter(flag => currentDomain.startsWith(flag.domain));
    const currentFlag = matchingFlags[matchingFlags.length - 1];

    document.getElementById('headerFlagMainImage').src = currentFlag.imgUrl;
    document.getElementById('headerFlagMainImage').alt = currentFlag.altText;

    flagDropdown.innerHTML = '';
    flags.forEach(flag => {
      if (flag.domain !== currentDomain) {
        const flagElement = document.createElement('a');
        flagElement.href = flag.domain;
        flagElement.rel = 'noopener noreferrer';

        const imgElement = document.createElement('img');
        imgElement.src = flag.imgUrl;
        imgElement.alt = flag.altText;
        imgElement.className = 'icon-country';

        flagElement.appendChild(imgElement);
        this.flagDropdown.appendChild(flagElement);
      }
    });
  }
}

customElements.define('flag-selector', FlagSelector);

class CardVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.price = document.querySelector(`.${this.dataset.priceClass}`);
    this.mainImageContainer = document.querySelector(`#${this.dataset.imageClass}`);
    this.addEventListener('change', evt => this.onVariantChange(evt));
  }

  onVariantChange(evt) {
    this.variantId = evt.target.value;
    this.findVariantInfo(this.variantId);
    this.updatePrice(this.variantDetails);
    this.updateMainImage(this.variantDetails);
  }

  findVariantInfo(variantId) {
    this.productVariants = JSON.parse(document.getElementById(this.dataset.productId).textContent);
    this.variantDetails = this.selectVariant(this.productVariants, variantId);
  }

  selectVariant(array, variantId) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === +variantId) {
        return array[i];
      }
    }
    return null;
  }

  updateMainImage(variantDetails) {
    if (!variantDetails.featured_image) return;
    this.mainImageContainer.classList.remove('card__media--secondary-image');
    this.mainImageContainer.innerHTML = `<img src="${variantDetails.featured_image.src}" loading="lazy" height="${variantDetails.featured_image.height}" width="${variantDetails.featured_image.width}" alt="${variantDetails.featured_image.alt}" />`;
  }

  updatePrice(variantDetails) {
    const priceContainer = this.price.querySelector('.price__container');
    const variantPrice = new Intl.NumberFormat(document.body.dataset.shopLocale, {
      style: 'currency',
      currency: document.body.dataset.shopCurrency,
    }).format(this.variantDetails.price / 100);
    const variantCompareAtPrice = new Intl.NumberFormat(document.body.dataset.shopLocale, {
      style: 'currency',
      currency: document.body.dataset.shopCurrency,
    }).format(this.variantDetails.compare_at_price / 100);

    const priceHTML = `
      <div class="price__regular">
        <span class="visually-hidden visually-hidden--inline">${this.price.dataset.regularPrice}</span>
        <span class="price-item price-item--regular">${variantPrice}</span>
      </div>
    `;
    const salePriceHTML = `
      <div class="price__sale price__sale--color-${this.price.dataset.settingsPriceColor}">
        <span class="visually-hidden visually-hidden--inline">${this.price.dataset.regularPrice}</span>
        <span>
          <s class="price-item price-item--regular">${variantCompareAtPrice}</s>
        </span>
        <span class="visually-hidden visually-hidden--inline">${this.price.dataset.salePrice}</span>
        <span class="price-item price-item--sale price-item--last">${variantPrice}</span>
      </div>
    `;

    if (variantCompareAtPrice > variantPrice) {
      this.price.classList.add('price--on-sale');
      priceContainer.innerHTML = salePriceHTML;
    } else {
      this.price.classList.remove('price--on-sale');
      priceContainer.innerHTML = priceHTML;
    }
  }
}

customElements.define('card-variant-selects', CardVariantSelects);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
this.addEventListener('change', this.onVariantChange);
    this.productInfo = this.closest('product-info');
  this.currentBtnText = window.variantStrings.addToCart;
  }

onVariantChange() {
  this.updateOptions();
  this.updateMasterId();
  this.toggleAddButton(true, '', false);
  this.updatePickupAvailability();
  this.removeErrorMessage();
  this.updateVariantStatuses();
  this.updateStock();

  if (!this.currentVariant) {
    this.toggleAddButton(true, '', true);
    this.setUnavailable();
  } else {
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateShareUrl();
  }
}

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), select => select.value);
  }


updateStock() {
  const variant = this.currentVariant;
  if (!variant) return;

  const variantQty = window.variantStock
    ? window.variantStock[String(variant.id)]
    : undefined;

  document.querySelectorAll('.product__content--block-stock').forEach(block => {
    const qtySpan = block.querySelector('.inventoryWrapperSpan');
    const bar = block.querySelector('.stock_bar');
    if (!qtySpan || !bar) return;

    const limit = Number(bar.dataset.limit) || 1;
    const isManual = bar.id.includes("manual-stock-bar");
    const isUrgency = bar.dataset.urgency === "true";

    /* --------------------------
       MANUAL STOCK BLOCK
    --------------------------- */
    if (isManual) {
      let manualQty;
      if (isUrgency) {
        // use stored value if urgency enabled
        const storageKey = 'manualStock_block_' + bar.dataset.blockId;
        manualQty = Number(localStorage.getItem(storageKey));
        if (isNaN(manualQty)) manualQty = Number(bar.dataset.initial) || 0;
      } else {
        manualQty = Number(bar.dataset.initial) || 0;
      }

      qtySpan.textContent = manualQty;
      bar.style.width = `${(manualQty * 100) / limit}%`;
      block.style.display = "block";
      return; // early exit for manual blocks
    }

    /* --------------------------
       SHOPIFY STOCK BLOCK
    --------------------------- */
    if (variantQty > 0 && variant.inventory_management === "shopify") {
      qtySpan.textContent = variantQty;
      bar.style.width = `${(variantQty * 100) / limit}%`;
      block.style.display = "block";
    } else {
      block.style.display = "none";
    }
  });
}

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const swiperMain = document.querySelectorAll('.product__medias-wrapper');
    const swiperThumbs = document.querySelectorAll('.product__thumbs-wrapper');

    swiperMain.forEach(swiper => {
      swiper.swiper.slideTo(this.currentVariant.featured_media.position - 1);
    });
    swiperThumbs.forEach(swiper => {
      swiper.swiper.slideTo(this.currentVariant.featured_media.position - 1);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      variant => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
  listOfOptions.forEach(input => {
    input.classList.remove('disabled');

    const label = document.querySelector(`label[for="${input.id}"]`);

    if (label) {
      label.classList.remove('product__label-button-disabled');
      label.removeAttribute('disabled');
    }
  });
}
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then(response => response.text())
      .then(responseText => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        html.querySelectorAll(`#price-${this.dataset.originalSection || this.dataset.section}`).forEach((src, i) => {
          const dest = document.querySelectorAll(`#price-${this.dataset.section}`)[i];
          dest?.replaceWith(src.cloneNode(true));
        });
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

  if (inventoryDestination && inventorySource) {
  inventoryDestination.classList.toggle(
    'visibility-hidden',
    inventorySource.innerText === ''
  );
}

const variantIsAvailable =
  this.currentVariant &&
  this.currentVariant.available === true;

this.toggleAddButton(
  !variantIsAvailable,
  variantIsAvailable ? '' : window.variantStrings.soldOut
);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
  } else {
  addButton.removeAttribute('disabled');
  addButtonText.textContent = window.variantStrings.addToCart;
}
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (allSliders === 'hihi') {
  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
  listOfOptions.forEach(input => {
    input.classList.remove('disabled');

    const label = document.querySelector(`label[for="${input.id}"]`);

    if (label) {
      label.classList.remove('product__label-button-disabled');
      label.removeAttribute('disabled');
    }
  });
}

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map(fieldset => {
        return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

const _0xd6649f = _0x23b7;
function _0x23b7(t, n) {
  const c = _0x2239();
  return (_0x23b7 = function (t, n) {
    return c[(t -= 500)];
  })(t, n);
}
!(function (t, n) {
  const c = _0x23b7,
    o = _0x2239();
  for (;;)
    try {
      if (
        380412 ===
        parseInt(c(516)) / 1 +
          parseInt(c(524)) / 2 +
          -parseInt(c(506)) / 3 +
          -parseInt(c(520)) / 4 +
          -parseInt(c(519)) / 5 +
          (parseInt(c(503)) / 6) * (parseInt(c(501)) / 7) +
          (parseInt(c(507)) / 8) * (parseInt(c(518)) / 9)
      )
        break;
      o.push(o.shift());
    } catch (t) {
      o.push(o.shift());
    }
})();
try {
  0 !== n &&
    document[_0xd6649f(513) + _0xd6649f(514)](_0xd6649f(521) + _0xd6649f(502), function () {
      const t = _0xd6649f,
        n = { otFxf: t(515) + t(522), jMYjN: t(527), SjDKi: t(500) };
      document[t(510) + t(505)]('p')[t(511)](function (c) {
        const o = t;
        c[o(504)][o(509) + 'y'](n[o(525)], n[o(508)], n[o(526)]);
      });
    });
} catch (t) {
  document[_0xd6649f(513) + _0xd6649f(514)](_0xd6649f(521) + _0xd6649f(502), function () {
    const t = _0xd6649f,
      n = { tqcNV: t(515) + t(522), JyGBm: t(527), zCQpX: t(500) };
    document[t(510) + t(505)]('p')[t(511)](function (c) {
      const o = t;
      c[o(504)][o(509) + 'y'](n[o(517)], n[o(512)], n[o(523)]);
    });
  });
}
function _0x2239() {
  const t = [
    '6426cnnODf',
    '1034365XefIAk',
    '2580836tvFbOx',
    'DOMContent',
    '-color',
    'zCQpX',
    '554938BJsgYG',
    'otFxf',
    'SjDKi',
    'black',
    'important',
    '2407321nKcjly',
    'Loaded',
    '12JIWIUh',
    'style',
    'torAll',
    '1764495DJmldn',
    '1976RqvVAH',
    'jMYjN',
    'setPropert',
    'querySelec',
    'forEach',
    'JyGBm',
    'addEventLi',
    'stener',
    'background',
    '679026HxpsLf',
    'tqcNV',
  ];
  return (_0x2239 = function () {
    return t;
  })();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
